<mat-toolbar>
  <div class="left">
    <button (click)="openChangeCustomerDialog()" *ngIf="customer$ | async as customer" disableRipple id="customer-selector" mat-button>
      <span>{{ customer.aliasName }}</span>
      <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div class="right">
    <a *ngIf="currentUserService.hasPermissions(['ui:irt:configuration']) | async"
       [matTooltip]="products['Integrate'] + ' ' + configName"
       class="cogwheel-btn ripple"
       i18n-matTooltip
       mat-icon-button
       matTooltipPosition="below"
       routerLink="/configuration"
       routerLinkActive="active"
    >
      <mat-icon>settings</mat-icon>
    </a>

    <button
      *ngIf="user$ | async as user"
      [matMenuTriggerFor]="menu"
      [matTooltip]="user.email"
      disableRipple
      mat-button
      matTooltipPosition="below">
      <ng-container>
        <ng-container *ngIf="user.fullName; then nameTmpl; else emailTmpl"></ng-container>
        <ng-template #nameTmpl>
          <span>{{user.fullName}}</span>
        </ng-template>
        <ng-template #emailTmpl>
          <span>{{user.email}}</span>
        </ng-template>
        <mat-icon>arrow_drop_down</mat-icon>
      </ng-container>
    </button>
  </div>
</mat-toolbar>

<mat-menu #menu="matMenu" xPosition="before">
  <button mat-menu-item routerLink="/auth/logout">
    <mat-icon>power_settings_new</mat-icon>
    <span>Sign Out</span>
  </button>
</mat-menu>
